import React, { useEffect, useState } from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Checkbox, Button, Alert } from '@mui/material';
import axiosInstance from '../axiosConfig';
import API_URL from '../config';

const DraftsManagement = () => {
  const [drafts, setDrafts] = useState([]);
  const [alert, setAlert] = useState(null);
  
  useEffect(() => {
    if (alert && alert.severity !== "info") {
      const timer = setTimeout(() => {
        setAlert(null);
      }, 3000); // 3 Sekunden Timeout
  
      return () => clearTimeout(timer); // Cleanup-Funktion für den Timer
    }
  }, [alert]);

  useEffect(() => {
    const fetchDrafts = async () => {
      const token = localStorage.getItem('authToken');
      try {
        const response = await axiosInstance.get('/admin/drafts', {
          headers: { Authorization: `${token}` },
        });
        setDrafts(response.data);
      } catch (error) {
        console.error('Fehler beim Laden der Entwürfe:', error);
      }
    };
    fetchDrafts();
  }, []);

  const handleCheckboxChange = (bookId) => {
    setDrafts((prevDrafts) =>
      prevDrafts.map((draft) =>
        draft._id === bookId ? { ...draft, template: !draft.template } : draft
      )
    );
  };

  const handleSaveTemplates = async () => {
    const token = localStorage.getItem('authToken');
    try {
      // Nur die Bücher, die template===true sind
      const bookIdsToSend = drafts
        .filter(draft => draft.template)
        .map(d => d._id);

      const response = await axiosInstance.post('/admin/templates', { bookIds: bookIdsToSend }, {
        headers: { Authorization: `${token}` },
      });

      if (response.status >= 200 && response.status < 300) {
        setAlert({
          severity: "success",
          message: "Änderungen erfolgreich übernommen."
        });
      }
    } catch (error) {
      // Bei einem Fehler die Fehlermeldung anzeigen
      setAlert({
        severity: "error",
        message: "Fehler beim Übernehmen der Änderungen. Bitte versuchen Sie es erneut."
      });
    }
  };

  return (
    <Box sx={{ ml: '1rem', mr: '1rem' }}>
      {alert && (
        <Box sx={{ marginTop: '1rem'}}>
          <Alert severity={alert.severity}>
            {alert.message}
          </Alert>
        </Box>
      )}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Book-Name</TableCell>
              <TableCell>Username</TableCell>
              <TableCell>Vorlage</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {drafts.map((draft) => (
              <TableRow key={draft._id}>
                <TableCell>{draft.name}</TableCell>
                <TableCell>{draft.username}</TableCell>
                <TableCell>
                  <Checkbox
                    checked={draft.template ?? false}
                    onChange={() => handleCheckboxChange(draft._id)}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Button variant="contained" size="small" color="primary" onClick={handleSaveTemplates} sx={{ mt: 2, mb: 2, bgcolor: 'primary.light', '&:hover': { color: '#fff' } }} type="button">
        Änderungen übernehmen
      </Button>
    </Box>
  );
};

export default DraftsManagement;